import { BenefitType } from '@/types/benefits/benefitTypes';
import { Translator } from '@/types/translator.type';

const BENEFIT_TYPES_TRANSLATED = (
  t: Translator,
): Record<BenefitType, string> => ({
  [BenefitType.ACTIVITY]: t('benefits.types.activity'),
  [BenefitType.HOTEL]: t('benefits.types.hotel'),
  [BenefitType.VOL]: t('benefits.types.vol'),
  [BenefitType.VEHICLE]: t('benefits.types.vehicle'),
  [BenefitType.VEHICLE_WITH_CHAUFFEUR]: t(
    'benefits.types.vehicleWithChauffeur',
  ),
  [BenefitType.MEAL]: t('benefits.types.meal'),
  [BenefitType.TRANSFER]: t('benefits.types.transfer'),
});

export const getBenefitTypeTranslatedLabel = (
  t: Translator,
  type: BenefitType,
) => {
  return BENEFIT_TYPES_TRANSLATED(t)[type];
};

export const getBenefitTypeName = (type: string): BenefitType => {
  switch (type) {
    case 'ACTIVITY':
      return BenefitType.ACTIVITY;
    case 'HOTEL':
      return BenefitType.HOTEL;
    case 'VOL':
      return BenefitType.VOL;
    case 'VEHICLE':
      return BenefitType.VEHICLE;
    case 'VEHICLE_WITH_CHAUFFEUR':
      return BenefitType.VEHICLE_WITH_CHAUFFEUR;
    case 'MEAL':
      return BenefitType.MEAL;
    case 'TRANSFER':
      return BenefitType.TRANSFER;
    default:
      return BenefitType.ACTIVITY;
  }
};

export const getBenefitNameFromType = (type: BenefitType) => {
  switch (type) {
    case BenefitType.ACTIVITY:
      return 'ACTIVITY';
    case BenefitType.HOTEL:
      return 'HOTEL';
    case BenefitType.VOL:
      return 'VOL';
    case BenefitType.VEHICLE:
      return 'VEHICLE';
    case BenefitType.VEHICLE_WITH_CHAUFFEUR:
      return 'VEHICLE_WITH_CHAUFFEUR';
    case BenefitType.MEAL:
      return 'MEAL';
    case BenefitType.TRANSFER:
      return 'TRANSFER';
  }
};
